import { render, staticRenderFns } from "./DFormGeneral.vue?vue&type=template&id=97a99cc0&scoped=true&"
import script from "./DFormGeneral.vue?vue&type=script&lang=js&"
export * from "./DFormGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a99cc0",
  null
  
)

export default component.exports